import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import VueOfficePdf from '@vue-office/pdf';

import { ref, onMounted } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Pdf',
  props: {
    fileUrl: {}
  },
  emits: ['error', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const ready = ref(false);
    const errorHandler = error => {
      emit('error', error);
    };
    const renderedHandler = () => {
      emit('success');
    };
    onMounted(() => {
      ready.value = true;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(VueOfficePdf), {
        src: _ctx.fileUrl,
        style: {
          "height": "100%"
        },
        onError: errorHandler,
        onRendered: renderedHandler
      }, null, 8, ["src"]);
    };
  }
});